var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDataQc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_usage",
    clipPath: "url(#clip0_2407_7079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8333 1.70801V4.23301C13.6583 4.64134 15.8333 7.05801 15.8333 9.99967C15.8333 10.7497 15.6833 11.458 15.4333 12.1163L17.6 13.3913C18.0666 12.358 18.3333 11.208 18.3333 9.99967C18.3333 5.68301 15.0416 2.12467 10.8333 1.70801ZM9.99996 15.833C6.77496 15.833 4.16663 13.2247 4.16663 9.99967C4.16663 7.05801 6.34163 4.64134 9.16663 4.23301V1.70801C4.94996 2.12467 1.66663 5.67467 1.66663 9.99967C1.66663 14.5997 5.39163 18.333 9.99163 18.333C12.75 18.333 15.1916 16.9913 16.7083 14.9247L14.5416 13.6497C13.475 14.983 11.8416 15.833 9.99996 15.833Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2407_7079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDataQc);
export default __webpack_public_path__ + "static/media/nav-data-qc.be48c37ca0cd723da017a345b55cdb52.svg";
export { ForwardRef as ReactComponent };